import type { Question } from '../../types';

export function getUniqueQuestions(questions: Question[]) {
  return questions.filter(
    (question, index, self) => index === self.findIndex((q) => q.id === question.id),
  );
}
